module.exports = __webpack_public_path__ + "img/bb-world-model.888b4604.png";